const GRADEBOOK_STATUS_ID = {
	active: 0,
	onChecking: 1,
	done: 2,
	reject: 3,
};

export default GRADEBOOK_STATUS_ID;
